var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 64L224 64L224 96L96 96L96 224L64 224L64 64zM576 64L576 224L544 224L544 96L416 96L416 64L576 64zM80 576L64 576L64 416L96 416L96 544L224 544L224 576L80 576zM576 576L416 576L416 544L544 544L544 416L576 416L576 576zM192 192L192 272L272 272L272 192L192 192zM160 160L304 160L304 304L160 304L160 160zM448 192L368 192L368 272L448 272L448 192zM368 160L480 160L480 304L336 304L336 160L368 160zM192 368L192 448L272 448L272 368L192 368zM160 336L304 336L304 480L160 480L160 336zM344 344L392 344L392 392L344 392L344 344zM392 424L392 472L344 472L344 424L392 424zM424 344L472 344L472 392L424 392L424 344zM472 424L472 472L424 472L424 424L472 424z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQr);
export default __webpack_public_path__ + "static/media/icon_qr.3d5ee2c157fe75b024f26f29f9e73afa.svg";
export { ForwardRef as ReactComponent };